import { Box, HStack, Link, Text } from '@chakra-ui/react'
import { MdFilterList } from 'react-icons/md'
import PropTypes from 'prop-types'
import React from 'react'

export const CommentFilter = ({ filters, onSyncFilters }) => {
  if (!filters || filters.length === 0) return null
  return (
    <Box
      p="16px"
      bg="brand.lightGray"
      textStyle="tinyHeader">
      <HStack>
        <Box mr="12px">
          <MdFilterList
            size="18px"
            color="brand.gray"
          />
        </Box>
        {filters.map((filter, index) => {
          return (
            <Text
              key={index}
              textStyle="italic"
              color="brand.textGray">
              {filter.text},
            </Text>
          )
        })}
      </HStack>
      <Box
        m="1px"
        ml="36px"
        textStyle="link">
        <Link
          title="Sync filters"
          onClick={onSyncFilters}>
          Sync filters
        </Link>
      </Box>
    </Box>
  )
}

CommentFilter.propTypes = {
  filters: PropTypes.array || PropTypes.string,
  onSyncFilters: PropTypes.func,
}
